export const REACT_ROOT_NODE_ID = 'checklight-root';
